import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6.66667 13.334H5C4.07953 13.334 3.33333 12.5878 3.33333 11.6673V5.00065C3.33333 4.08018 4.07953 3.33398 5 3.33398H11.6667C12.5871 3.33398 13.3333 4.08018 13.3333 5.00065V6.66732M8.33333 16.6673H15C15.9205 16.6673 16.6667 15.9211 16.6667 15.0007V8.33398C16.6667 7.41351 15.9205 6.66732 15 6.66732H8.33333C7.41286 6.66732 6.66667 7.41351 6.66667 8.33398V15.0007C6.66667 15.9211 7.41286 16.6673 8.33333 16.6673Z" />
  </svg>
);
